import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { UserRole } from 'interfaces';
import { ROUTES } from 'config';
import { useCurrentRole, useAPlayerStatus } from 'hooks';
import { SimpleInterpolation } from 'styled-components';
import { Layout } from '../Layout/Layout';

export type PrivateRouteProps = PropsWithChildren<{
  customLayoutStyle?: SimpleInterpolation;
  hideLeftBlock?: boolean;
  allowedRoles?: UserRole[];
  aPlayerStatusRequired?: boolean;
}>;

export const PrivateRoute = ({
  children,
  customLayoutStyle,
  hideLeftBlock,
  allowedRoles,
  aPlayerStatusRequired,
}: PrivateRouteProps) => {
  const userRole = useCurrentRole()?.code;
  const aPlayerStatus = useAPlayerStatus();

  const isCorrectRole = aPlayerStatusRequired
    ? aPlayerStatus
    : allowedRoles?.includes(userRole as UserRole) ?? true;

  return (
    <>
      {!userRole && <Navigate to={ROUTES.login} />}
      {!isCorrectRole && <Navigate to={ROUTES.forbidden} />}
      {userRole && isCorrectRole && (
        <Layout
          customLayoutStyle={customLayoutStyle}
          hideLeftBlock={hideLeftBlock}
        >
          {children}
        </Layout>
      )}
    </>
  );
};
